import React from "react"
import PropTypes from "prop-types"
import { Formik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { useSnackbar } from "react-simple-snackbar"

import {
  Input,
  Form,
  ButtonWithLoader,
  Modal,
  SnackBarOptions,
} from "../../../../Shared"
import { defaultRequiredText } from "../../../../../constants"
import { handleBackendErrors } from "../../../../../utilities"

export const EmailQuote = ({ quoteId, isVisible, dismissFunc }) => {
  const [openSnackbar] = useSnackbar(SnackBarOptions)

  const saveQuote = async (values, setSubmitting) => {
    try {
      await axios({
        method: "post",
        url: `${process.env.GATSBY_API_BASE_URL}/quote/email`,
        data: {
          quoteId: quoteId,
          email: values.email,
        },
      })
      dismissFunc()
      openSnackbar("Quote saved (Check your email)")
    } catch (error) {
      openSnackbar(handleBackendErrors(error, "save quote"))
    }
    setSubmitting(false)
  }

  return (
    <Modal
      heading="Email your quote"
      isVisible={isVisible}
      dismissFunc={dismissFunc}
      additionalClasses="email-quote"
    >
      Email your quote and return to it at any time to book your installation
      <Formik
        initialValues={{ email: "" }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Must be a valid email address")
            .required(defaultRequiredText),
        })}
        onSubmit={(values, { setSubmitting }) => {
          saveQuote(values, setSubmitting)
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <Input name="email" label="Your email" placeholder="Your email" />
            <ButtonWithLoader type="submit" disabled={isSubmitting}>
              Send email
            </ButtonWithLoader>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

EmailQuote.propTypes = {
  quoteId: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  dismissFunc: PropTypes.func.isRequired,
}
